import React from 'react';

import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

interface TabItemProps {
  label: string;
  value?: string;
  selectedItem?: string;
  handleSelect?: Function;
  link?: string;
}

const TabItem: React.FC<TabItemProps> = ({
  label,
  value,
  link,
  handleSelect,
  selectedItem,
  ...rest
}) => {
  const isSelected = value === selectedItem;

  return (
    <StyledLink
      to={link ? link : ''}
      as={link ? Link : 'div'}
      data-testid={rest['data-testid']}
      onClick={() => handleSelect && handleSelect(value)}
      data-selected={isSelected}
      active={isSelected}
    >
      {label}
    </StyledLink>
  );
};

export default TabItem;

const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'as' && prop !== 'active' && prop !== 'isSSKU',
})<{ active: boolean }>`
  font-size: ${({ theme }) => (theme.isSsku ? '20' : '16')}px;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  text-transform: ${({ theme }) => (theme.isSsku ? 'none' : 'uppercase')};
  line-height: ${({ theme }) => theme.isSsku && '1.2'};
  color: ${({ theme, active }) =>
    active ? theme.palette.common.white : theme.palette.common.header.text};
  padding: 5px 0;
  font-weight: bold;
  position: relative;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 3px;
    width: ${({ active }) => (active ? 99 : 0)}%;
    left: 0;
    background-color: ${({ theme }) => theme.palette.primary.main};
    transition: 0.5s ease all 0.3s;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.common.white};
    &:after {
      width: 99%;
      transition: 0.3s ease all;
    }
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 10px 0;
  }
`;
